import { z } from 'zod';
import { PROGRESS_TIMEFRAME_VALUES } from '@/components/loop-dashboard/progress/progressTimeframe';
import {
  INSIGHTS_SORT_DIRECTIONS,
  INSIGHTS_SORTABLE_FIELDS,
} from '@/lib/api/types/insights/sorting';
import {
  compactDateFilterSchema,
  compactPicklistFilterSchema,
} from '@/lib/zod-schemas/common/compactFilterSchemas';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';

const compactGroupBySchema = z
  .string()
  .regex(/^(team|itemType|integration)(_(?:team|itemType|integration))?$/)
  .optional()
  .catch(undefined);

export const insightsSearchSchema = z.object({
  scopeItemId: z
    .preprocess(
      (v) => (v === '' || v === undefined ? undefined : Number(v)),
      z.number().int().positive(),
    )
    .optional(),
  teamId: compactPicklistFilterSchema,
  statusId: compactPicklistFilterSchema,
  itemTypeId: compactPicklistFilterSchema,
  integrationId: compactPicklistFilterSchema,
  plannedStartDateTime: compactDateFilterSchema,
  plannedFinishDateTime: compactDateFilterSchema,
  orderBy: z.enum(INSIGHTS_SORTABLE_FIELDS).optional(),
  orderDir: z.enum(INSIGHTS_SORT_DIRECTIONS).optional(),
  groupBy: compactGroupBySchema,
  progressTimeframe: z.enum(PROGRESS_TIMEFRAME_VALUES).optional(),
});

export const insightsDeliverablesSearchSchema = insightsSearchSchema.and(itemPanelSearchSchema);
